import { Box } from "@mui/material";
import { useHasFeature } from "shared-ui/Feature";
import { Loading } from "shared-ui/global/Loading";
import { StreamChatProvider } from "../../contexts/StreamChatContext";
import { useNutritionFlags } from "../../hooks/useNutritionFlags";
import { useMeForStreamChatQuery, useMyMavenEncryptedUserInfoQuery } from "../../types";
import { useUser } from "../../utils/tokens";
import { OrgRouter } from "./Org/OrgRouter";
import { OrgAndStaffRouterProps } from "./PrimaryNavUtils";

export const OrgApp = ({ orgs, onOrgChange, axleDataForNavbar }: OrgAndStaffRouterProps) => {
  const hasMessaging = useHasFeature("messaging");
  const { isUnityMessagingEnabled } = useNutritionFlags();
  const user = useUser();
  const showUnityMessaging = isUnityMessagingEnabled && Boolean(user?.orgMembership?.teamworksId);

  const { data, loading } = useMeForStreamChatQuery({ skip: !hasMessaging || showUnityMessaging });
  const { data: myUserData, loading: myUserDataLoading } = useMyMavenEncryptedUserInfoQuery();

  if (showUnityMessaging && myUserData) {
    return (
      <OrgRouter
        orgs={orgs}
        onOrgChange={onOrgChange}
        signedUserData={myUserData?.myMavenEncryptedUserInfo}
        axleDataForNavbar={axleDataForNavbar}
      />
    );
  } else if (loading || myUserDataLoading) {
    return (
      <Box height={"100%"} width={"100%"}>
        <Loading />
      </Box>
    );
  } else if (hasMessaging && data) {
    return (
      <StreamChatProvider key="stream-chat-provider" meForStreamChatResult={data}>
        <OrgRouter
          orgs={orgs}
          onOrgChange={onOrgChange}
          signedUserData={myUserData?.myMavenEncryptedUserInfo}
          axleDataForNavbar={axleDataForNavbar}
        />
      </StreamChatProvider>
    );
  }
  // keeping fallback here for no messaging case
  // even thought it's the same as the unity messaging case
  // it simplifies the conditional logic
  return (
    <OrgRouter
      orgs={orgs}
      onOrgChange={onOrgChange}
      signedUserData={myUserData?.myMavenEncryptedUserInfo}
      axleDataForNavbar={axleDataForNavbar}
    />
  );
};
